<template>
  <div style="margin-top:10px;">
    <Title title="相关人物" />
    <el-descriptions border style="margin-top:10px;">
      <el-descriptions-item
        v-for="prop in personProp"
        :key="prop.value"
        :label="prop.label"
      >
        {{ prop.value }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import Title from '@/components/Title'
import { getPerson } from '@/api/PersonApi'
export default {
  name: 'PersonIntro',
  components: {
    Title
  },
  props: {
    personId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      person: {
        personId: '',
        name: '',
        intro: ''
      }
    }
  },
  computed: {
    personProp() {
      const prop = []
      for (const key in this.person) {
        switch (key) {
          case 'name':
            prop.push({ label: '姓名', value: this.person[key] })
            break
          case 'country':
            prop.push({ label: '朝代', value: this.person[key] })
            break
          case 'home':
            prop.push({ label: '籍贯', value: this.person[key] })
            break
          case 'zihao': {
            let zihaoStr = ''
            if (this.person[key]) {
              const zihaoArr = JSON.parse(this.person[key])
              zihaoArr.forEach(zihao => {
                zihaoStr += zihao + ' '
              })
            }
            prop.push({ label: '字号', value: zihaoStr })
            break
          }
          case 'job': {
            let jobStr = ''
            if (this.person[key]) {
              const jobArr = JSON.parse(this.person[key])
              jobArr.forEach(job => {
                jobStr += job.place + job.name + ' '
              })
            }
            prop.push({ label: '标签', value: jobStr })
            break
          }

          default:
            break
        }
      }
      return prop
    }
  },
  created() {
    getPerson(this.personId)
      .then(resp => {
        this.person = resp.data
      })
  }

}
</script>

<style lang="scss" scoped>
.content-wrap {
  padding: 20px;
  .content {
    line-height: 30px;
    text-indent: 2em;
  }
}

.el-descriptions {
  ::v-deep .el-descriptions__title {
    font-size: 22px;
    font-weight: bold;
  }
  ::v-deep .el-descriptions-item__label {
    font-size: 14px;
    font-weight: bold;
    padding: 0 12px;
    width: 100px;
    text-align: justify;
    text-align: justify;
    text-align-last: justify;
    text-justify: inter-ideograph;
    color: #595959;
  }
  ::v-deep .el-descriptions-item__content {
    color: #000;
  }
}

</style>
